import { engineComponent } from "neo-common";
import { ComponentTypes } from "./ComponentTypes";

/**
 * Configuration hold elements configurations from xml by ID.
 * @class Configuration
 */
@engineComponent(ComponentTypes.Element)
export class Configuration {
    static Configurations: { [id: string]: Element } = {};
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Configuration.ts
 **/